export default "<!-- pdf-content.component.html -->\r\n<div>\r\n    <button (click)=\"downloadPDF()\">Descargar PDF</button>\r\n</div>"